import React, { useState, useEffect, useRef } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import {
    Container,
    Button,
    Col,
    Row,
    Label,
    Card,
    CardBody,
    Input,
    InputGroup
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb3";
import {
    getCompanies as onGetCompanies,
    getListAccountNumber as onGetListAccountNumber,
    addAccountTransactionClientBank as onAddAccountTransactionClientBank,
} from "../../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { NotifHelper } from "../../../components/Common/NotifHelper"
import PulseLoader from "react-spinners/PulseLoader";

const ClientTransactionCreateByAccountNumber = (props) => {
    //meta title
    document.title = "Add By Account Number (Bank) | Client Transaction | Des Counts";
    const dispatch = useDispatch();
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [optionCompany, setOptionCompany] = useState(null)
    const [selectedAccountNumber, setSelectedAccountNumber] = useState(null);
    const [optionAccountNumber, setOptionAccountNumber] = useState(null)
    const [selectedTipeBank, setSelectedTipeBank] = useState(null);
    const [optionTipeBank, setOptionTipeBank] = useState([
        { value: "cimb", label: "CIMB" },
        { value: "mandiri", label: "Mandiri" },
    ])
    const [fileUpload, setFileUpload] = useState(null)

    const {
        companies,
        loadingCompany,
        accountNumbers,
        loadingAccountNumber,
        accounts,
        loadingAccount,
        loading
    } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        accountNumbers: state.AccountNumber.listAccountNumber,
        loadingAccountNumber: state.AccountNumber.loading,
        loading: state.AccountTransactionClient.loading,
    }));

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [companies]);

    useEffect(() => {
        if (accountNumbers) {
            setOptionAccountNumber(accountNumbers.map(item => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [accountNumbers]);


    function handleSelectCompany(val) {
        setSelectedCompany(val)
    }

    function handleSelectAccountNumber(e) {
        setSelectedAccountNumber(e);
        // validation.setFieldValue("accountNumberId", e ? e.value : null, true)
    }

    function handleSelectTipeBank(e) {
        setSelectedTipeBank(e);
    }

    function handleSubmit() {
        if (selectedCompany && selectedAccountNumber && selectedTipeBank && fileUpload) {
            const data = new FormData()
            data.append('files', fileUpload)
            dispatch(onAddAccountTransactionClientBank(selectedCompany.value, selectedAccountNumber.value, selectedTipeBank.value, data, props.history))
        }
    }

    useEffect(() => {
        dispatch(onGetCompanies({}))
    }, [dispatch])

    useEffect(() => {
        if (selectedCompany) {
            dispatch(onGetListAccountNumber({ companyId: selectedCompany.value }))
        }
    }, [selectedCompany])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Client Transaction" breadcrumbItem1="Transaction" breadcrumbItem2="Add By Account Number (Bank)" />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <Row className="mb-3">
                                        <Col>
                                            <div>
                                                <Label>Company</Label><Label className="text-danger">*</Label>
                                                <Select
                                                    value={selectedCompany}
                                                    onChange={(val) => {
                                                        handleSelectCompany(val)
                                                    }}
                                                    options={optionCompany}
                                                    isLoading={loadingCompany}
                                                    isClearable={false}
                                                    className="select2-selection"
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div>
                                                <Label>Account Number</Label><Label className="text-danger">*</Label>
                                                <Select
                                                    isDisabled={selectedCompany == null}
                                                    value={selectedAccountNumber}
                                                    onChange={(val) => {
                                                        handleSelectAccountNumber(val)
                                                    }}
                                                    options={optionAccountNumber}
                                                    isLoading={loadingAccountNumber}
                                                    isClearable={false}
                                                    className="select2-selection"
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div>
                                                <Label>Tipe Bank</Label><Label className="text-danger">*</Label>
                                                <Select
                                                    value={selectedTipeBank}
                                                    onChange={(val) => {
                                                        handleSelectTipeBank(val)
                                                    }}
                                                    options={optionTipeBank}
                                                    isClearable={false}
                                                    className="select2-selection"
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col sm={12}>
                                            <Label htmlFor="formFile" className="form-label">File Excel (.xlsx)</Label>
                                            <Input className="form-control" type="file" onChange={(e) => {
                                                if (e.target.files.length > 0) {
                                                    setFileUpload(e.target.files[0])
                                                }
                                                else {
                                                    setFileUpload(null)
                                                }
                                            }} accept=".xlsx" />
                                        </Col>
                                    </Row>
                                    {
                                        !loading &&
                                        <>
                                            <Row>
                                                <Col>
                                                    <Link to="/client-transaction/transaction">
                                                        <Button color="primary" className="float-end">
                                                            Cancel
                                                        </Button>
                                                    </Link>
                                                    <Button color="success" className="float-end me-2" onClick={() => {
                                                        handleSubmit()
                                                    }}
                                                     disabled={selectedAccountNumber == null || selectedCompany == null || selectedTipeBank == null || fileUpload == null}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {
                                        loading &&
                                        <Row className="mt-3">
                                            <Col className="text-center">
                                                <PulseLoader size={10} color={'#fff'} className="text-white" />
                                            </Col>
                                        </Row>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <text className="text-danger fst-italic">Note : Currently only available for CIMB bank.</text>
                </Container>
            </div>
        </React.Fragment>
    )
}

ClientTransactionCreateByAccountNumber.propTypes = {
    className: PropTypes.string,
    preGlobalFilteredRows: PropTypes.any,
};

export default ClientTransactionCreateByAccountNumber
